export default {
  title: 'Kieli',
  save_changes: 'Tallenna muutokset',
};
